import { createAction } from "@ngrx/store";

export const ResetDataSavedAction = createAction('[Terms Conditions Form] reset data saved property');